module.exports = __webpack_public_path__ + "img/video_image_1.7b4b56f0.svg";